import React, { useState, useEffect, useRef } from 'react';

// ── Sicherheit: API URL aus .env
const API_URL       = process.env.REACT_APP_API_URL || "https://china-restaurant-backend-production.up.railway.app";
const RESTAURANT_ID = process.env.REACT_APP_RESTAURANT_ID || "1";
const API_KEY       = process.env.REACT_APP_API_KEY || "";   // ← NEU
const DELIVERY_FEE  = 2.00;
const MAX_QTY       = 20;
const ORDER_COOLDOWN_MS = 120_000;

const DELIVERY_ZONES = [
  {
    id: 'alsdorf',
    label: 'Alsdorf (Stadtgebiet)',
    sub: 'außer Busch, Ofden, Zopp',
    min: 15,
  },
  {
    id: 'extended',
    label: 'Weitere Umgebung',
    sub: 'Busch · Ofden · Zopp · Würselen-Broichweiden · Linden-Neusen · Eschweiler-Kinzweiler · Hehlrath · Aldenhoven-Schleiden · Siersdorf',
    min: 28,
  },
];

const sanitize = (str) =>
  String(str ?? '')
    .replace(/[<>'";&`\\]/g, '')
    .trim()
    .slice(0, 500);

const isValidPhone = (p) => /^[\d\s\+\-\(\)\/]{6,20}$/.test(p.trim());
const isValidName  = (n) => n.trim().length >= 2 && n.trim().length <= 80;

const canPlaceOrder = () => {
  const last = parseInt(localStorage.getItem('lw_last_order') || '0', 10);
  return Date.now() - last > ORDER_COOLDOWN_MS;
};
const markOrderPlaced = () =>
  localStorage.setItem('lw_last_order', String(Date.now()));

const isDrinkCategory = (name = '') => {
  const n = name.toLowerCase();
  return n.includes('getr') || n.includes('drink') || n.includes('tee') || n.includes('kaffee') || n.includes('bier');
};

const getQty        = (cart, id) => cart.find(i => i.item_id === id)?.quantity || 0;
const getTotal      = (cart)     => cart.reduce((s, i) => s + i.unit_price * i.quantity, 0);
const getTotalItems = (cart)     => cart.reduce((s, i) => s + i.quantity, 0);
const getTotalExDrinks = (cart) =>
  cart.filter(i => !isDrinkCategory(i.category || '')).reduce((s, i) => s + i.unit_price * i.quantity, 0);

const T = {
  bg:          '#0A0A0A',
  bgCard:      '#141414',
  bgCardHover: '#1C1C1C',
  bgInput:     '#0F0F0F',
  border:      '#242424',
  gold:        '#C9A052',
  goldDim:     '#7A5F2E',
  white:       '#F0EEE8',
  textSec:     '#888278',
  textMuted:   '#4A4845',
  green:       '#4ADE80',
  red:         '#f87171',
  overlay:     'rgba(0,0,0,0.88)',
};

const CSS = `
  .om * { box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif; }
  .om ::-webkit-scrollbar { width: 3px; height: 3px; }
  .om ::-webkit-scrollbar-track { background: transparent; }
  .om ::-webkit-scrollbar-thumb { background: #2A2A2A; border-radius: 2px; }
  @keyframes omUp    { from { opacity:0; transform:translateY(28px); } to { opacity:1; transform:translateY(0); } }
  @keyframes omFade  { from { opacity:0; transform:translateY(8px);  } to { opacity:1; transform:translateY(0); } }
  @keyframes omPulse { 0%,100% { transform:scale(1); } 50% { transform:scale(1.25); } }
  @keyframes omSpin  { to { transform:rotate(360deg); } }
  @keyframes omToast { from { transform:translateX(110%); opacity:0; } to { transform:translateX(0); opacity:1; } }
  @keyframes omShimmer { 0% { background-position:-200% 0; } 100% { background-position:200% 0; } }
  @keyframes omCheck { from { stroke-dashoffset:50; } to { stroke-dashoffset:0; } }
  .om-modal  { animation: omUp 0.35s cubic-bezier(0.4,0,0.2,1) both; }
  .om-card   { animation: omFade 0.3s ease both; transition: border-color .2s, box-shadow .2s, transform .15s; }
  .om-card:hover { transform: translateY(-1px); border-color: #343434 !important; }
  .om-btn    { transition: all .15s ease; cursor: pointer; border: none; outline: none; }
  .om-btn:hover:not(:disabled) { filter: brightness(1.1); }
  .om-btn:active:not(:disabled) { transform: scale(0.95); }
  .om-btn:disabled { opacity: 0.45; cursor: not-allowed; }
  .om-input  { outline: none; transition: border-color .15s, box-shadow .15s; font-family: inherit; font-size: 14px; }
  .om-input:focus { border-color: #C9A052 !important; box-shadow: 0 0 0 3px rgba(201,160,82,0.1); }
  .om-input.om-err { border-color: #f87171 !important; box-shadow: 0 0 0 3px rgba(248,113,113,0.1); }
  .om-pill   { transition: all .2s ease; cursor: pointer; }
  .om-pill:hover { color: #C9A052 !important; }
  .om-toast  { animation: omToast 0.35s cubic-bezier(0.4,0,0.2,1) both; }
  .om-pulse  { animation: omPulse 0.35s ease; }
  .om-skel   { background: linear-gradient(90deg, #141414 25%, #1C1C1C 50%, #141414 75%); background-size: 200% 100%; animation: omShimmer 1.5s infinite; border-radius: 8px; }
  .om-paycard { transition: all .2s ease; cursor: pointer; border: none; text-align: left; }
  .om-paycard:hover { transform: translateY(-2px); }
  .om-zone   { transition: all .2s ease; cursor: pointer; border: none; text-align: left; width: 100%; }
  .om-zone:hover { transform: translateY(-1px); }
  .om-dsgvo-link { color: #7A5F2E; text-decoration: underline; transition: color .15s; }
  .om-dsgvo-link:hover { color: #C9A052; }
  @media (max-width: 600px) {
    .om-sidebar { display:none !important; }
    .om-topcat  { display:flex !important; }
    .om-area    { margin-left:0 !important; margin-top: 52px !important; }
    .om-grid    { grid-template-columns: 1fr !important; }
    .om-paygrid { grid-template-columns: 1fr !important; }
    .om-zonegrid { grid-template-columns: 1fr !important; }
  }
`;

const SI = ({ d, size = 20, sw = "1.8", ...p }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" {...p}>
    {d}
  </svg>
);

const Ic = {
  X:      (p) => <SI {...p} d={<><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>}/>,
  Plus:   (p) => <SI {...p} sw="2.5" d={<><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></>}/>,
  Minus:  (p) => <SI {...p} sw="2.5" d={<line x1="5" y1="12" x2="19" y2="12"/>}/>,
  Check:  (p) => <SI {...p} sw="2.5" d={<polyline points="20 6 9 17 4 12"/>}/>,
  Back:   (p) => <SI {...p} d={<polyline points="15 18 9 12 15 6"/>}/>,
  Trash:  (p) => <SI {...p} size={15} d={<><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></>}/>,
  Cart:   (p) => <SI {...p} d={<><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></>}/>,
  Pin:    (p) => <SI {...p} d={<><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></>}/>,
  Shield: (p) => <SI {...p} d={<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>}/>,
};

// ─────────────────────────────────────────────────────────────────────────────
const OrderModal = ({ isOpen, onClose }) => {
  const [cats,      setCats]      = useState([]);
  const [loading,   setLoading]   = useState(false);
  const [cart,      setCart]      = useState([]);
  const [activeCat, setActiveCat] = useState(null);
  const [view,      setView]      = useState('menu');

  const [name,      setName]      = useState('');
  const [address,   setAddress]   = useState('');
  const [phone,     setPhone]     = useState('');
  const [notes,     setNotes]     = useState('');
  const [zone,      setZone]      = useState(null);
  const [errors,    setErrors]    = useState({});
  const [payMethod, setPayMethod] = useState(null);
  const [sending,   setSending]   = useState(false);
  const [toasts,    setToasts]    = useState([]);
  const [pulse,     setPulse]     = useState(false);
  const [orderId,   setOrderId]   = useState(null);
  const tid    = useRef(0);
  const cssRef = useRef(null);

  useEffect(() => {
    if (cssRef.current) return;
    const el = document.createElement('style');
    el.textContent = CSS;
    document.head.appendChild(el);
    cssRef.current = el;
    return () => { el.remove(); cssRef.current = null; };
  }, []);

  useEffect(() => {
    if (isOpen) {
      if (cats.length === 0) loadMenu();
      setView('menu');
      setPayMethod(null);
      setErrors({});
    }
  }, [isOpen]);

  const loadMenu = async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/restaurants/${RESTAURANT_ID}/menu`);
      if (!r.ok) throw new Error();
      const d = await r.json();
      const list = d?.categories || (Array.isArray(d) ? d : []);
      setCats(list);
      if (list.length) setActiveCat(list[0].name);
    } catch { toast('Fehler beim Laden der Speisekarte'); }
    finally  { setLoading(false); }
  };

  const toast = (text, type = 'info') => {
    const id = ++tid.current;
    setToasts(p => [...p, { id, text, type }]);
    setTimeout(() => setToasts(p => p.filter(t => t.id !== id)), 3500);
  };

  const addItem = (item) => {
    setCart(p => {
      const ex = p.find(i => i.item_id === item.id);
      if (ex && ex.quantity >= MAX_QTY) {
        toast(`Maximal ${MAX_QTY}× pro Gericht möglich`);
        return p;
      }
      if (ex) return p.map(i => i.item_id === item.id ? { ...i, quantity: i.quantity + 1 } : i);
      return [...p, {
        item_id:    item.id,
        name:       item.name,
        unit_price: item.price,
        quantity:   1,
        category:   item.category || '',
      }];
    });
    setPulse(true); setTimeout(() => setPulse(false), 350);
    toast(`${item.name} hinzugefügt`);
  };

  const decItem = (id) => setCart(p => {
    const ex = p.find(i => i.item_id === id);
    if (!ex) return p;
    if (ex.quantity === 1) return p.filter(i => i.item_id !== id);
    return p.map(i => i.item_id === id ? { ...i, quantity: i.quantity - 1 } : i);
  });

  const delItem = (id) => setCart(p => p.filter(i => i.item_id !== id));

  const validateInputs = () => {
    const errs = {};
    if (!isValidName(name))
      errs.name = 'Name muss 2–80 Zeichen haben';
    if (!address.trim() || address.trim().length < 10)
      errs.address = 'Bitte vollständige Adresse angeben';
    if (!isValidPhone(phone))
      errs.phone = 'Ungültige Telefonnummer';
    if (!zone)
      errs.zone = 'Bitte Liefergebiet wählen';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const checkMinOrder = () => {
    const selectedZone = DELIVERY_ZONES.find(z => z.id === zone);
    if (!selectedZone) return false;
    const totalExDrinks = getTotalExDrinks(cart);
    if (totalExDrinks < selectedZone.min) {
      toast(`Mindestbestellwert für ${selectedZone.label}: ${selectedZone.min},00 € (ohne Getränke). Aktuell: ${totalExDrinks.toFixed(2)} €`);
      return false;
    }
    return true;
  };

  const goToPayment = () => {
    if (!validateInputs()) {
      toast('Bitte alle Pflichtfelder korrekt ausfüllen');
      return;
    }
    if (!checkMinOrder()) return;
    setView('payment');
  };

  const submitCashOrder = async () => {
    if (!canPlaceOrder()) {
      toast('Bitte warte kurz vor der nächsten Bestellung (2 Minuten)');
      return;
    }
    if (sending) return;
    setSending(true);
    try {
      const res = await fetch(`${API_URL}/restaurants/${RESTAURANT_ID}/orders`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-API-Key': API_KEY },
        body: JSON.stringify({
          restaurant_id: String(RESTAURANT_ID),
          items: cart.map(i => ({
            item_id:    sanitize(i.item_id),
            name:       sanitize(i.name),
            unit_price: Number(i.unit_price),
            quantity:   Math.min(Math.max(Math.floor(i.quantity), 1), MAX_QTY),
          })),
          customer: {
            name:    sanitize(name),
            address: sanitize(address),
            phone:   sanitize(phone),
            notes:   sanitize(notes),
            zone:    zone,
          },
          delivery_fee: DELIVERY_FEE,
        }),
      });
      if (!res.ok) throw new Error();
      const data = await res.json();
      markOrderPlaced();
      setOrderId(data.id?.slice(-6).toUpperCase() || 'OK');
      setView('success');
      setCart([]);
      setName(''); setAddress(''); setPhone(''); setNotes(''); setZone(null);
    } catch { toast('Bestellung konnte nicht gesendet werden — bitte erneut versuchen'); }
    finally  { setSending(false); }
  };

  const startStripePayment = async () => {
    if (!canPlaceOrder()) {
      toast('Bitte warte kurz vor der nächsten Bestellung (2 Minuten)');
      return;
    }
    if (sending) return;
    setSending(true);
    try {
      const res = await fetch(`${API_URL}/create-payment-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-API-Key': API_KEY },
        body: JSON.stringify({
          restaurant_id: String(RESTAURANT_ID),
          items: cart.map(i => ({
            item_id:    sanitize(i.item_id),
            name:       sanitize(i.name),
            unit_price: Number(i.unit_price),
            quantity:   Math.min(Math.max(Math.floor(i.quantity), 1), MAX_QTY),
          })),
          customer: {
            name:    sanitize(name),
            address: sanitize(address),
            phone:   sanitize(phone),
            notes:   sanitize(notes),
            zone:    zone,
          },
          delivery_fee: DELIVERY_FEE,
        }),
      });
      if (!res.ok) throw new Error();
      const data = await res.json();
      if (!data.checkout_url?.startsWith('https://')) throw new Error('Ungültige Weiterleitungs-URL');
      markOrderPlaced();
      window.location.href = data.checkout_url;
    } catch { toast('Online-Zahlung konnte nicht gestartet werden'); }
    finally  { setSending(false); }
  };

  if (!isOpen) return null;

  const total         = getTotal(cart);
  const totalExDrinks = getTotalExDrinks(cart);
  const grandTotal    = total + DELIVERY_FEE;
  const itemCount     = getTotalItems(cart);
  const notesLeft     = 200 - notes.length;
  const selectedZone  = DELIVERY_ZONES.find(z => z.id === zone);
  const minMet        = selectedZone ? totalExDrinks >= selectedZone.min : false;
  const minProgress   = selectedZone ? Math.min((totalExDrinks / selectedZone.min) * 100, 100) : 0;
  const activeCatData = cats.find(c => c.name === activeCat);

  return (
    <div className="om" style={{
      position:'fixed', inset:0, zIndex:9999,
      background:T.overlay, backdropFilter:'blur(6px)',
      display:'flex', alignItems:'center', justifyContent:'center', padding:16,
    }} onClick={onClose}>

      {/* ── TOASTS ── */}
      <div style={{ position:'fixed', top:20, right:20, zIndex:10001, display:'flex', flexDirection:'column', gap:8, pointerEvents:'none' }}>
        {toasts.map(t => (
          <div key={t.id} className="om-toast" style={{
            background:'#1C1C1C', border:`1px solid ${t.type === 'error' ? T.red : T.border}`,
            borderRadius:8, padding:'10px 16px', fontSize:13, color:T.white,
            boxShadow:'0 8px 24px rgba(0,0,0,0.4)', maxWidth:280,
          }}>{t.text}</div>
        ))}
      </div>

      {/* ── MODAL ── */}
      <div className="om-modal" style={{
        background:T.bg, borderRadius:18, width:'100%', maxWidth:680,
        maxHeight:'90vh', display:'flex', flexDirection:'column',
        border:`1px solid ${T.border}`, boxShadow:'0 40px 80px rgba(0,0,0,0.7)',
        overflow:'hidden',
      }} onClick={e => e.stopPropagation()}>

        {/* HEADER */}
        <div style={{
          padding:'16px 20px', borderBottom:`1px solid ${T.border}`,
          display:'flex', alignItems:'center', gap:12, flexShrink:0,
        }}>
          {(view === 'checkout' || view === 'payment') && (
            <button className="om-btn" onClick={() => setView(view === 'payment' ? 'checkout' : 'menu')}
              style={{ background:'none', color:T.textSec, padding:4, marginRight:4 }}>
              <Ic.Back size={22}/>
            </button>
          )}
          <div style={{ flex:1 }}>
            <div style={{ fontSize:16, fontWeight:700, color:T.white }}>
              {view === 'menu'     && 'Speisekarte'}
              {view === 'checkout' && 'Bestellung & Lieferdaten'}
              {view === 'payment'  && 'Zahlungsart wählen'}
              {view === 'success'  && 'Bestellung bestätigt'}
            </div>
            {view === 'menu' && !loading && cats.length > 0 && (
              <div style={{ fontSize:12, color:T.textMuted, marginTop:1 }}>
                {cats.reduce((s,c) => s + (c.items?.length||0), 0)} Gerichte verfügbar
              </div>
            )}
          </div>
          <button className="om-btn" onClick={onClose}
            style={{ background:T.bgCard, border:`1px solid ${T.border}`, borderRadius:8, padding:7, color:T.textSec }}>
            <Ic.X size={18}/>
          </button>
        </div>

        {/* MINDESTBESTELLWERT PROGRESS */}
        {view === 'menu' && selectedZone && (
          <div style={{ padding:'10px 20px', background:T.bgCard, borderBottom:`1px solid ${T.border}`, flexShrink:0 }}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:6 }}>
              <span style={{ fontSize:12, color:T.textSec }}>
                {minMet
                  ? 'Mindestbestellwert erreicht'
                  : `Noch ${(selectedZone.min - totalExDrinks).toFixed(2)} € bis Mindestbestellwert (ohne Getränke)`}
              </span>
              <span style={{ fontSize:12, color: minMet ? T.green : T.gold, fontWeight:600 }}>
                {totalExDrinks.toFixed(2)} € / {selectedZone.min} €
              </span>
            </div>
            <div style={{ background:T.border, borderRadius:4, height:4, overflow:'hidden' }}>
              <div style={{
                height:'100%', borderRadius:4,
                background: minMet
                  ? `linear-gradient(90deg, #16a34a, ${T.green})`
                  : `linear-gradient(90deg, ${T.goldDim}, ${T.gold})`,
                width:`${minProgress}%`, transition:'width 0.4s ease',
              }}/>
            </div>
          </div>
        )}

        {/* LIEFERGEBÜHR INFO */}
        {view === 'menu' && !selectedZone && (
          <div style={{
            padding:'10px 20px', background:T.bgCard,
            borderBottom:`1px solid ${T.border}`, flexShrink:0,
            display:'flex', alignItems:'center', gap:8,
          }}>
            <Ic.Pin size={14} style={{ color:T.gold, flexShrink:0 }}/>
            <span style={{ fontSize:12, color:T.textSec }}>
              Liefergebühr: <strong style={{ color:T.white }}>2,00 €</strong>
              <span style={{ color:T.textMuted }}> · Liefergebiet im Checkout wählen</span>
            </span>
          </div>
        )}

        {/* ── BODY ── */}
        <div style={{ flex:1, overflow:'hidden', display:'flex', flexDirection:'column', minHeight:0 }}>

          {/* ══ MENÜ ══ */}
          {view === 'menu' && (
            <div style={{ display:'flex', flex:1, overflow:'hidden', minHeight:0, position:'relative' }}>

              {/* Sidebar Desktop */}
              <div className="om-sidebar" style={{
                width:180, flexShrink:0, borderRight:`1px solid ${T.border}`,
                overflowY:'auto', padding:'12px 8px', display:'flex', flexDirection:'column', gap:4,
              }}>
                {cats.map(cat => (
                  <button key={cat.name} className="om-pill om-btn" onClick={() => setActiveCat(cat.name)}
                    style={{
                      display:'flex', alignItems:'center', padding:'10px 12px',
                      borderRadius:10, background: activeCat===cat.name ? '#1C1C1C' : 'transparent',
                      border: `1px solid ${activeCat===cat.name ? T.border : 'transparent'}`,
                      color: activeCat===cat.name ? T.gold : T.textSec, textAlign:'left',
                    }}>
                    <span style={{ fontSize:13, fontWeight: activeCat===cat.name ? 600 : 400 }}>{cat.name}</span>
                  </button>
                ))}
              </div>

              {/* Top-Kategorien Mobil */}
              <div className="om-topcat" style={{
                display:'none', position:'absolute', top:0, left:0, right:0, zIndex:10,
                overflowX:'auto', background:T.bg, borderBottom:`1px solid ${T.border}`,
                padding:'10px 16px', gap:8,
              }}>
                {cats.map(cat => (
                  <button key={cat.name} className="om-pill om-btn" onClick={() => setActiveCat(cat.name)}
                    style={{
                      flexShrink:0, padding:'7px 14px', borderRadius:20,
                      background: activeCat===cat.name ? T.gold : T.bgCard,
                      border: `1px solid ${activeCat===cat.name ? T.gold : T.border}`,
                      color: activeCat===cat.name ? T.bg : T.textSec,
                      fontSize:12, fontWeight:600, whiteSpace:'nowrap',
                    }}>
                    {cat.name}
                  </button>
                ))}
              </div>

              {/* Gerichte */}
              <div className="om-area" style={{ flex:1, overflowY:'auto', padding:'20px 16px', marginLeft:0 }}>
                {loading ? (
                  <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
                    {[...Array(5)].map((_,i) => <div key={i} className="om-skel" style={{ height:88 }}/>)}
                  </div>
                ) : activeCatData ? (
                  <div>
                    <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:14 }}>
                      <span style={{ fontSize:13, fontWeight:700, color:T.gold, letterSpacing:'0.08em', textTransform:'uppercase' }}>
                        {activeCatData.name}
                      </span>
                      <div style={{ flex:1, height:1, background:T.border }}/>
                      {isDrinkCategory(activeCatData.name) && (
                        <span style={{ fontSize:10, color:T.textMuted, background:T.bgCard, border:`1px solid ${T.border}`, borderRadius:4, padding:'2px 6px' }}>
                          nicht auf Mindestbestellwert
                        </span>
                      )}
                    </div>
                    <div className="om-grid" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                      {(activeCatData.items || []).map(item => {
                        const qty = getQty(cart, item.id);
                        return (
                          <div key={item.id} className="om-card" style={{
                            background:T.bgCard, borderRadius:12,
                            border:`1px solid ${qty > 0 ? T.goldDim : T.border}`,
                            padding:'14px 14px 12px', display:'flex', flexDirection:'column', gap:8,
                            boxShadow: qty > 0 ? `0 0 0 1px ${T.goldDim}` : 'none',
                          }}>
                            <div style={{ flex:1 }}>
                              <div style={{ fontSize:14, fontWeight:600, color:T.white, lineHeight:1.35, marginBottom:4 }}>
                                {item.name}
                              </div>
                              {item.description && (
                                <div style={{ fontSize:11.5, color:T.textMuted, lineHeight:1.4 }}>
                                  {item.description}
                                </div>
                              )}
                            </div>
                            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:4 }}>
                              <span style={{ fontSize:15, fontWeight:700, color:T.gold }}>
                                {item.price.toFixed(2)} €
                              </span>
                              {qty === 0 ? (
                                <button className="om-btn" onClick={() => addItem({ ...item, category: activeCatData.name })} style={{
                                  background:T.gold, color:T.bg, borderRadius:8, padding:'6px 12px',
                                  fontSize:13, fontWeight:700, display:'flex', alignItems:'center', gap:5,
                                }}>
                                  <Ic.Plus size={13}/> Hinzufügen
                                </button>
                              ) : (
                                <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                                  <button className="om-btn" onClick={() => decItem(item.id)} style={{
                                    background:T.bgCardHover, color:T.white, borderRadius:6,
                                    width:28, height:28, display:'flex', alignItems:'center', justifyContent:'center',
                                  }}>
                                    <Ic.Minus size={14}/>
                                  </button>
                                  <span style={{ fontSize:14, fontWeight:700, color:T.white, minWidth:16, textAlign:'center' }}>{qty}</span>
                                  <button className="om-btn"
                                    onClick={() => qty < MAX_QTY ? addItem({ ...item, category: activeCatData.name }) : toast(`Max. ${MAX_QTY}× möglich`)}
                                    style={{
                                      background: qty >= MAX_QTY ? T.bgCardHover : T.gold,
                                      color: qty >= MAX_QTY ? T.textMuted : T.bg,
                                      borderRadius:6, width:28, height:28,
                                      display:'flex', alignItems:'center', justifyContent:'center',
                                    }}>
                                    <Ic.Plus size={14}/>
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          )}

          {/* ══ CHECKOUT ══ */}
          {view === 'checkout' && (
            <div style={{ flex:1, overflowY:'auto', padding:'20px 20px 24px' }}>

              {/* Bestellübersicht */}
              <div style={{ marginBottom:24 }}>
                <div style={{ fontSize:11, fontWeight:700, color:T.textMuted, letterSpacing:'0.1em', textTransform:'uppercase', marginBottom:12 }}>
                  Deine Bestellung
                </div>
                {cart.map(item => (
                  <div key={item.item_id} style={{
                    display:'flex', alignItems:'center', gap:12,
                    padding:'12px 0', borderBottom:`1px solid ${T.border}`,
                  }}>
                    <div style={{
                      width:32, height:32, borderRadius:8, background:T.bgCard,
                      border:`1px solid ${T.border}`, display:'flex', alignItems:'center',
                      justifyContent:'center', color:T.gold, fontWeight:700, fontSize:13, flexShrink:0,
                    }}>
                      {item.quantity}x
                    </div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:14, fontWeight:500, color:T.white }}>{item.name}</div>
                      <div style={{ fontSize:12, color:T.textMuted }}>{(item.unit_price * item.quantity).toFixed(2)} €</div>
                    </div>
                    <button className="om-btn" onClick={() => delItem(item.item_id)}
                      style={{ background:'none', color:T.textMuted, padding:4 }}>
                      <Ic.Trash/>
                    </button>
                  </div>
                ))}

                {/* Preisaufstellung */}
                <div style={{ marginTop:12, padding:'12px 0', borderTop:`1px solid ${T.border}` }}>
                  <div style={{ display:'flex', justifyContent:'space-between', marginBottom:8 }}>
                    <span style={{ fontSize:13, color:T.textSec }}>Zwischensumme</span>
                    <span style={{ fontSize:13, color:T.white }}>{total.toFixed(2)} €</span>
                  </div>
                  <div style={{ display:'flex', justifyContent:'space-between', marginBottom:8 }}>
                    <span style={{ fontSize:13, color:T.textSec }}>Liefergebühr</span>
                    <span style={{ fontSize:13, color:T.white }}>{DELIVERY_FEE.toFixed(2)} €</span>
                  </div>
                  <div style={{ display:'flex', justifyContent:'space-between', paddingTop:10, borderTop:`1px solid ${T.border}` }}>
                    <span style={{ fontSize:14, fontWeight:700, color:T.white }}>Gesamtbetrag</span>
                    <span style={{ fontSize:16, fontWeight:700, color:T.gold }}>{grandTotal.toFixed(2)} €</span>
                  </div>
                </div>
              </div>

              {/* Liefergebiet */}
              <div style={{ marginBottom:16 }}>
                <div style={{ fontSize:11, fontWeight:700, color:T.textMuted, letterSpacing:'0.1em', textTransform:'uppercase', marginBottom:12 }}>
                  Liefergebiet *
                </div>
                <div className="om-zonegrid" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom: errors.zone ? 6 : 0 }}>
                  {DELIVERY_ZONES.map(z => (
                    <button key={z.id} className="om-zone om-btn" onClick={() => { setZone(z.id); setErrors(e => ({...e, zone:null})); }}
                      style={{
                        padding:'14px 16px', borderRadius:12,
                        background: zone === z.id ? 'rgba(201,160,82,0.10)' : T.bgCard,
                        border: `2px solid ${zone === z.id ? T.gold : errors.zone ? T.red : T.border}`,
                        color: T.white,
                      }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4 }}>
                        <Ic.Pin size={14} style={{ color: zone === z.id ? T.gold : T.textMuted, flexShrink:0 }}/>
                        <span style={{ fontSize:13, fontWeight:700, color: zone === z.id ? T.gold : T.white }}>{z.label}</span>
                      </div>
                      <div style={{ fontSize:11, color:T.textMuted, lineHeight:1.4 }}>{z.sub}</div>
                      <div style={{ marginTop:8, fontSize:12, fontWeight:700, color: zone === z.id ? T.gold : T.textSec }}>
                        ab {z.min},00 € <span style={{ fontWeight:400, color:T.textMuted }}>(ohne Getränke)</span>
                      </div>
                    </button>
                  ))}
                </div>
                {errors.zone && <div style={{ fontSize:12, color:T.red, marginTop:4 }}>{errors.zone}</div>}

                {zone && !minMet && (
                  <div style={{
                    marginTop:10, padding:'10px 14px',
                    background:'rgba(248,113,113,0.08)', border:`1px solid rgba(248,113,113,0.25)`,
                    borderRadius:10, fontSize:12, color:T.red,
                  }}>
                    Mindestbestellwert noch nicht erreicht — noch {(selectedZone.min - totalExDrinks).toFixed(2)} € (ohne Getränke) fehlen.
                  </div>
                )}
                {zone && minMet && (
                  <div style={{
                    marginTop:10, padding:'10px 14px',
                    background:'rgba(74,222,128,0.08)', border:`1px solid rgba(74,222,128,0.2)`,
                    borderRadius:10, fontSize:12, color:T.green,
                    display:'flex', alignItems:'center', gap:8,
                  }}>
                    <Ic.Check size={14}/> Mindestbestellwert erreicht
                  </div>
                )}
              </div>

              {/* Persönliche Daten */}
              <div>
                <div style={{ fontSize:11, fontWeight:700, color:T.textMuted, letterSpacing:'0.1em', textTransform:'uppercase', marginBottom:12 }}>
                  Lieferdaten
                </div>

                <input
                  className={`om-input ${errors.name ? 'om-err' : ''}`}
                  placeholder="Vor- und Nachname *"
                  value={name}
                  onChange={e => { setName(e.target.value); setErrors(p => ({...p, name:null})); }}
                  maxLength={80}
                  style={{
                    display:'block', width:'100%', background:T.bgInput,
                    border:`1px solid ${errors.name ? T.red : T.border}`, borderRadius:10,
                    padding:'13px 14px', color:T.white, marginBottom:4,
                  }}
                />
                {errors.name && <div style={{ fontSize:12, color:T.red, marginBottom:8 }}>{errors.name}</div>}
                {!errors.name && <div style={{ marginBottom:10 }}/>}

                <input
                  className={`om-input ${errors.address ? 'om-err' : ''}`}
                  placeholder="Straße, Hausnummer, PLZ, Ort *"
                  value={address}
                  onChange={e => { setAddress(e.target.value); setErrors(p => ({...p, address:null})); }}
                  maxLength={150}
                  style={{
                    display:'block', width:'100%', background:T.bgInput,
                    border:`1px solid ${errors.address ? T.red : T.border}`, borderRadius:10,
                    padding:'13px 14px', color:T.white, marginBottom:4,
                  }}
                />
                {errors.address && <div style={{ fontSize:12, color:T.red, marginBottom:8 }}>{errors.address}</div>}
                {!errors.address && <div style={{ marginBottom:10 }}/>}

                <input
                  className={`om-input ${errors.phone ? 'om-err' : ''}`}
                  placeholder="Handynummer *"
                  value={phone}
                  onChange={e => { setPhone(e.target.value); setErrors(p => ({...p, phone:null})); }}
                  maxLength={20}
                  type="tel"
                  style={{
                    display:'block', width:'100%', background:T.bgInput,
                    border:`1px solid ${errors.phone ? T.red : T.border}`, borderRadius:10,
                    padding:'13px 14px', color:T.white, marginBottom:4,
                  }}
                />
                {errors.phone && <div style={{ fontSize:12, color:T.red, marginBottom:8 }}>{errors.phone}</div>}
                {!errors.phone && <div style={{ marginBottom:10 }}/>}

                <div style={{ position:'relative' }}>
                  <textarea
                    className="om-input"
                    placeholder="Anmerkung (optional) — z.B. extra scharf, kein Koriander, 3. OG klingeln ..."
                    value={notes}
                    maxLength={200}
                    onChange={e => setNotes(e.target.value)}
                    rows={3}
                    style={{
                      display:'block', width:'100%', background:T.bgInput,
                      border:`1px solid ${T.border}`, borderRadius:10,
                      padding:'13px 14px', color:T.white, resize:'none',
                      fontFamily:'inherit', fontSize:14,
                    }}
                  />
                  <div style={{
                    position:'absolute', bottom:10, right:12,
                    fontSize:11, color: notesLeft < 20 ? T.red : T.textMuted,
                  }}>
                    {notesLeft} Zeichen übrig
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ══ ZAHLUNGSAUSWAHL ══ */}
          {view === 'payment' && (
            <div style={{ flex:1, overflowY:'auto', padding:'24px 20px' }}>
              <div style={{ fontSize:11, fontWeight:700, color:T.textMuted, letterSpacing:'0.1em', textTransform:'uppercase', marginBottom:16 }}>
                Zahlungsart wählen
              </div>

              <div className="om-paygrid" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                <button className="om-paycard om-btn" onClick={() => setPayMethod('cash')}
                  style={{
                    padding:20, borderRadius:14,
                    background: payMethod==='cash' ? 'rgba(201,160,82,0.10)' : T.bgCard,
                    border: `2px solid ${payMethod==='cash' ? T.gold : T.border}`,
                    color: T.white,
                  }}>
                  <div style={{ marginBottom:12 }}>
                    <svg width={32} height={32} viewBox="0 0 24 24" fill="none" stroke={payMethod==='cash' ? T.gold : T.textSec} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="2" y="6" width="20" height="14" rx="2"/>
                      <path d="M12 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>
                      <path d="M6 10h.01M18 10h.01"/>
                    </svg>
                  </div>
                  <div style={{ fontWeight:700, fontSize:15, marginBottom:4, color: payMethod==='cash' ? T.gold : T.white }}>Bar bei Lieferung</div>
                  <div style={{ fontSize:12, color:T.textMuted, lineHeight:1.5 }}>Zahlung in bar an den Fahrer</div>
                </button>

                <button className="om-paycard om-btn" onClick={() => setPayMethod('stripe')}
                  style={{
                    padding:20, borderRadius:14,
                    background: payMethod==='stripe' ? 'rgba(201,160,82,0.10)' : T.bgCard,
                    border: `2px solid ${payMethod==='stripe' ? T.gold : T.border}`,
                    color: T.white,
                  }}>
                  <div style={{ marginBottom:12 }}>
                    <svg width={32} height={32} viewBox="0 0 24 24" fill="none" stroke={payMethod==='stripe' ? T.gold : T.textSec} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="1" y="4" width="22" height="16" rx="2"/>
                      <line x1="1" y1="10" x2="23" y2="10"/>
                    </svg>
                  </div>
                  <div style={{ fontWeight:700, fontSize:15, marginBottom:4, color: payMethod==='stripe' ? T.gold : T.white }}>Online bezahlen</div>
                  <div style={{ fontSize:12, color:T.textMuted, lineHeight:1.5 }}>
                    Apple Pay · Google Pay<br/>PayPal · Kreditkarte
                  </div>
                </button>
              </div>

              {/* Zusammenfassung */}
              <div style={{ marginTop:20, padding:'14px 16px', background:T.bgCard, border:`1px solid ${T.border}`, borderRadius:12 }}>
                <div style={{ fontSize:12, color:T.textMuted, marginBottom:10 }}>Bestellung für {name}</div>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:6 }}>
                  <span style={{ fontSize:13, color:T.textSec }}>Speisen & Getränke</span>
                  <span style={{ fontSize:13, color:T.white }}>{total.toFixed(2)} €</span>
                </div>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:10, paddingBottom:10, borderBottom:`1px solid ${T.border}` }}>
                  <span style={{ fontSize:13, color:T.textSec }}>Liefergebühr</span>
                  <span style={{ fontSize:13, color:T.white }}>{DELIVERY_FEE.toFixed(2)} €</span>
                </div>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <span style={{ fontSize:14, fontWeight:700, color:T.white }}>Gesamtbetrag</span>
                  <span style={{ fontSize:18, fontWeight:700, color:T.gold }}>{grandTotal.toFixed(2)} €</span>
                </div>
                <div style={{ marginTop:10, fontSize:12, color:T.textMuted }}>
                  {address.slice(0,40)}{address.length>40?'...':''}
                </div>
                {notes && (
                  <div style={{ marginTop:6, fontSize:12, color:T.textMuted, fontStyle:'italic' }}>
                    "{notes.slice(0,60)}{notes.length>60?'...':''}"
                  </div>
                )}
              </div>

              {/* Sicherheitshinweis */}
              <div style={{
                marginTop:14, padding:'10px 14px',
                background:'rgba(201,160,82,0.05)', border:`1px solid rgba(201,160,82,0.15)`,
                borderRadius:10, display:'flex', alignItems:'center', gap:8,
                fontSize:11, color:T.textMuted,
              }}>
                <Ic.Shield size={13} style={{ color:T.goldDim, flexShrink:0 }}/>
                Deine Daten werden verschlüsselt übertragen und nicht weitergegeben.
              </div>

              {/* ── NEU: DSGVO-Hinweis ── */}
              <div style={{ marginTop:10, fontSize:11, color:T.textMuted, textAlign:'center', lineHeight:1.7 }}>
                Mit der Bestellung akzeptierst du unsere{' '}
                <a
                  href="https://speisio.de/datenschutz.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="om-dsgvo-link"
                >
                  Datenschutzerklärung
                </a>
                {' '}und das{' '}
                <a
                  href="https://speisio.de/impressum.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="om-dsgvo-link"
                >
                  Impressum
                </a>.
              </div>
            </div>
          )}

          {/* ══ ERFOLG ══ */}
          {view === 'success' && (
            <div style={{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:32, gap:16, textAlign:'center' }}>
              <div style={{ width:72, height:72, borderRadius:'50%', background:'rgba(74,222,128,0.1)', border:'2px solid #4ADE80', display:'flex', alignItems:'center', justifyContent:'center' }}>
                <svg width={36} height={36} viewBox="0 0 24 24" fill="none" stroke="#4ADE80" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" strokeDasharray="50" strokeDashoffset="0" style={{animation:'omCheck 0.5s 0.2s ease both'}}/>
                </svg>
              </div>
              <div style={{ fontSize:22, fontWeight:700, color:T.white }}>Bestellung eingegangen</div>
              <div style={{ fontSize:13, color:T.textSec }}>Das Restaurant wurde benachrichtigt — ca. 25–35 Min. Lieferzeit</div>
              {orderId && (
                <div style={{ background:T.bgCard, border:`1px solid ${T.border}`, borderRadius:10, padding:'10px 24px' }}>
                  <div style={{ fontSize:11, color:T.textMuted, marginBottom:4, letterSpacing:'0.08em' }}>BESTELL-ID</div>
                  <div style={{ fontSize:20, fontWeight:700, color:T.gold, letterSpacing:'0.1em' }}># {orderId}</div>
                </div>
              )}
              <button className="om-btn" onClick={onClose}
                style={{ marginTop:8, background:T.gold, color:T.bg, borderRadius:10, padding:'12px 32px', fontWeight:700, fontSize:14 }}>
                Schließen
              </button>
            </div>
          )}
        </div>

        {/* ── FOOTER BUTTONS ── */}

        {/* Menü → Checkout */}
        {view === 'menu' && itemCount > 0 && (
          <div style={{ padding:'14px 20px', borderTop:`1px solid ${T.border}`, flexShrink:0 }}>
            <button className={`om-btn ${pulse ? 'om-pulse' : ''}`} onClick={() => setView('checkout')}
              style={{
                width:'100%', padding:'14px 20px', borderRadius:12,
                background:`linear-gradient(135deg, ${T.goldDim} 0%, ${T.gold} 100%)`,
                color:T.bg, fontWeight:700, fontSize:15, display:'flex', alignItems:'center', justifyContent:'space-between',
                boxShadow:`0 4px 20px rgba(201,160,82,0.25)`,
              }}>
              <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                <Ic.Cart size={18}/>
                <span>{itemCount} Artikel</span>
              </div>
              <span>{total.toFixed(2)} € + 2,00 € Liefergebühr</span>
            </button>
          </div>
        )}

        {/* Checkout → Zahlungsauswahl */}
        {view === 'checkout' && (
          <div style={{ padding:'14px 20px', borderTop:`1px solid ${T.border}`, flexShrink:0 }}>
            <button className="om-btn" onClick={goToPayment}
              disabled={!minMet && !!zone}
              style={{
                width:'100%', padding:'14px 20px', borderRadius:12,
                background: (!zone || minMet)
                  ? `linear-gradient(135deg, ${T.goldDim} 0%, ${T.gold} 100%)`
                  : T.bgCard,
                color: (!zone || minMet) ? T.bg : T.textMuted,
                fontWeight:700, fontSize:15, display:'flex', alignItems:'center', justifyContent:'center', gap:10,
              }}>
              <Ic.Check size={18}/> Weiter zur Zahlungsart · {grandTotal.toFixed(2)} €
            </button>
          </div>
        )}

        {/* Zahlung → Bestellen */}
        {view === 'payment' && (
          <div style={{ padding:'14px 20px', borderTop:`1px solid ${T.border}`, flexShrink:0 }}>
            <button className="om-btn"
              onClick={payMethod === 'stripe' ? startStripePayment : payMethod === 'cash' ? submitCashOrder : undefined}
              disabled={!payMethod || sending}
              style={{
                width:'100%', padding:'14px 20px', borderRadius:12,
                background: (payMethod && !sending) ? `linear-gradient(135deg, ${T.goldDim} 0%, ${T.gold} 100%)` : T.bgCard,
                color: (payMethod && !sending) ? T.bg : T.textMuted,
                fontWeight:700, fontSize:15, display:'flex', alignItems:'center', justifyContent:'center', gap:10,
              }}>
              {sending ? (
                <>
                  <svg style={{animation:'omSpin 1s linear infinite'}} width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" strokeOpacity="0.25"/>
                    <path d="M12 2a10 10 0 0 1 10 10"/>
                  </svg>
                  Wird verarbeitet...
                </>
              ) : payMethod === 'stripe' ? (
                <><Ic.Check size={18}/> Jetzt online bezahlen · {grandTotal.toFixed(2)} €</>
              ) : payMethod === 'cash' ? (
                <><Ic.Check size={18}/> Verbindlich bestellen · {grandTotal.toFixed(2)} €</>
              ) : (
                'Zahlungsart wählen'
              )}
            </button>
          </div>
        )}

        {/* ── NEU: PERMANENTER FOOTER ── */}
        <div style={{
          padding:'10px 20px', borderTop:`1px solid ${T.border}`,
          display:'flex', alignItems:'center', justifyContent:'center',
          gap:24, flexShrink:0, background:T.bg,
        }}>
          <a
            href="https://speisio.de/impressum.html"
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize:11, color:T.textMuted, textDecoration:'none', transition:'color .15s' }}
            onMouseEnter={e => e.target.style.color = T.textSec}
            onMouseLeave={e => e.target.style.color = T.textMuted}
          >
            Impressum
          </a>
          <span style={{ fontSize:11, color:T.textMuted }}>·</span>
          <a
            href="https://speisio.de/datenschutz.html"
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize:11, color:T.textMuted, textDecoration:'none', transition:'color .15s' }}
            onMouseEnter={e => e.target.style.color = T.textSec}
            onMouseLeave={e => e.target.style.color = T.textMuted}
          >
            Datenschutz
          </a>
          <span style={{ fontSize:11, color:T.textMuted }}>·</span>
          <span style={{ fontSize:11, color:T.textMuted }}>Powered by Speisio</span>
        </div>

      </div>
    </div>
  );
};

export default OrderModal;
